<div
  class="confirm-modal"
  [class.confirm-modal--warning]="hasMismatch()"
  role="dialog"
  aria-modal="true"
  aria-labelledby="confirm-link-title"
  tabindex="-1"
  appFocusTrap
>
  <header class="confirm-modal__header flex align-center justify-between">
    <div class="flex align-center gap-12">
      <span
        class="confirm-modal__header-icon"
        [class.confirm-modal__header-icon--warning]="hasMismatch()"
        aria-hidden="true"
      >
        <app-icon
          [name]="hasMismatch() ? 'warning' : 'link'"
          size="sm"
          color="custom"
          customColor="currentColor"
          role="presentation"
        ></app-icon>
      </span>
      <div>
        <h2 id="confirm-link-title" class="confirm-modal__title fs-16 fw-700 m-0">
          {{ headerTitle() }}
        </h2>
        <p class="confirm-modal__subtitle fs-12 m-0">{{ headerSubtitle() }}</p>
      </div>
    </div>
    <button
      type="button"
      class="confirm-modal__close"
      (click)="cancel()"
      aria-label="Close confirm and link modal"
    >
      <app-icon
        name="close"
        size="sm"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
    </button>
  </header>

  <div class="modal-body">
    <div class="comparison-grid">
      <div class="column-card column-card--submitted">
        <div class="column-header">
          <app-icon
            name="person"
            size="sm"
            color="custom"
            customColor="currentColor"
            role="presentation"
          ></app-icon>
          Submitted by Patient
        </div>
        <div class="field-list">
          <div class="field-group" [class.field-group--mismatch]="!nameMatches()">
            <div class="field-label flex align-center gap-4">
              @if (!nameMatches()) {
              <app-icon
                name="warning"
                size="xs"
                color="custom"
                customColor="currentColor"
                class="mismatch-icon"
                role="presentation"
              ></app-icon>
              } Name
            </div>
            <div class="field-value" [class.field-value--mismatch]="!nameMatches()">
              {{ submittedName() || '—' }}
            </div>
          </div>
          <div class="field-group" [class.field-group--mismatch]="!dobMatches()">
            <div class="field-label flex align-center gap-4">
              @if (!dobMatches()) {
              <app-icon
                name="warning"
                size="xs"
                color="custom"
                customColor="currentColor"
                class="mismatch-icon"
                role="presentation"
              ></app-icon>
              } Date of Birth
            </div>
            <div class="field-value" [class.field-value--mismatch]="!dobMatches()">
              {{ portalDob() }}
            </div>
          </div>
          <div class="field-group" [class.field-group--mismatch]="isPortalIdentifierMismatch()">
            <div class="field-label flex align-center gap-4">
              @if (isPortalIdentifierMismatch()) {
              <app-icon
                name="warning"
                size="xs"
                color="custom"
                customColor="currentColor"
                class="mismatch-icon"
                role="presentation"
              ></app-icon>
              } {{ portalIdentifierLabel() }}
            </div>
            <div
              class="field-value"
              [class.field-value--mismatch]="isPortalIdentifierMismatch()"
              [class.masked]="isPortalIdentifierMasked()"
              [attr.aria-label]="portalIdentifierAriaLabel()"
            >
              {{ portalIdentifierValue() }}
            </div>
          </div>
          <div class="field-group">
            <div class="field-label">Email</div>
            <div class="field-value">{{ request().emailAddress }}</div>
          </div>
          <div class="field-group">
            <div class="field-label">Phone</div>
            <div class="field-value">{{ portalPhone() }}</div>
          </div>
        </div>
      </div>
      <div class="column-card column-card--match" [class.column-card--warning]="hasMismatch()">
        <div class="column-header" [class.column-header--primary]="!hasMismatch()">
          <app-icon
            [name]="hasMismatch() ? 'warning' : 'check_circle'"
            color="custom"
            customColor="currentColor"
            size="sm"
            role="presentation"
          ></app-icon>
          Selected Match
        </div>
        <div class="field-list">
          <div class="field-group" [class.field-group--mismatch]="!nameMatches()">
            <div class="field-label flex align-center gap-4">
              @if (!nameMatches()) {
              <app-icon
                name="warning"
                size="xs"
                color="custom"
                customColor="currentColor"
                class="mismatch-icon"
                role="presentation"
              ></app-icon>
              } Name
            </div>
            <div class="field-value" [class.field-value--mismatch]="!nameMatches()">
              {{ selectedPatient()?.displayName ?? '—' }}
            </div>
          </div>
          <div class="field-group" [class.field-group--mismatch]="!dobMatches()">
            <div class="field-label flex align-center gap-4">
              @if (!dobMatches()) {
              <app-icon
                name="warning"
                size="xs"
                color="custom"
                customColor="currentColor"
                class="mismatch-icon"
                role="presentation"
              ></app-icon>
              } Date of Birth
            </div>
            <div class="field-value" [class.field-value--mismatch]="!dobMatches()">
              {{ patientDob() }}
            </div>
          </div>
          <div class="field-group">
            <div class="field-label">SSN (last 5)</div>
            <div
              class="field-value"
              [class.masked]="patientHasSsn()"
              [attr.aria-label]="patientSsnAriaLabel()"
            >
              {{ patientSsnDisplay() }}
            </div>
          </div>
          <div class="field-group" [class.field-group--mismatch]="!medicalRecordNumberMatches()">
            <div class="field-label flex align-center gap-4">
              @if (!medicalRecordNumberMatches()) {
              <app-icon
                name="warning"
                size="xs"
                color="custom"
                customColor="currentColor"
                class="mismatch-icon"
                role="presentation"
              ></app-icon>
              } MRN
            </div>
            <div class="field-value" [class.field-value--mismatch]="!medicalRecordNumberMatches()">
              {{ selectedPatient()?.medicalRecordNumber ?? '—' }}
            </div>
          </div>
          <div class="field-group">
            <div class="field-label">PCP</div>
            <div class="field-value">{{ patientPcp() }}</div>
          </div>
          <div class="field-group">
            <div class="field-label">Email</div>
            <div class="field-value">{{ patientEmail() }}</div>
          </div>
          <div class="field-group">
            <div class="field-label">Phone</div>
            <div class="field-value">{{ patientPhone() }}</div>
          </div>
        </div>
      </div>
    </div>

    @if (hasMismatch()) {
    <div class="banner warning modal-banner flex align-start gap-12" role="alert">
      <app-icon
        class="banner__icon banner__icon--warning"
        name="warning"
        size="sm"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
      <div class="banner-text">
        <strong
          >{{ mismatches().length }} {{ mismatches().length === 1 ? 'field does' : 'fields do' }}
          not match the patient record.</strong
        >
        Provide a justification below to proceed with linking.
        <ul class="mismatch-list">
          @for (mismatch of mismatches(); track mismatch.field) {
          <li>
            <strong>{{ mismatch.field }}:</strong> submitted “{{ mismatch.submitted }}” — patient
            record “{{ mismatch.matched }}”
          </li>
          }
        </ul>
      </div>
    </div>
    } @else {
    <div
      class="banner success modal-banner flex align-start gap-12"
      role="status"
      aria-live="polite"
    >
      <app-icon
        class="banner__icon"
        name="check_circle"
        size="sm"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
      <span class="banner-text"
        >{{ consistentFields() }} consistent. This link will be recorded in the audit log under your
        account.</span
      >
    </div>
    } @if (hasMismatch()) {
    <div class="override-justification">
      <label for="override-justification" class="override-justification__label fs-12 fw-600"
        >Override Justification
        <span class="override-justification__required" aria-hidden="true">*</span
        ><span class="sr-only">(required)</span></label
      >
      <textarea
        id="override-justification"
        class="override-justification__input field__input fs-12"
        rows="3"
        [value]="overrideJustification()"
        (input)="updateOverrideJustification($any($event.target).value)"
        (blur)="markJustificationTouched()"
        placeholder="Describe the additional evidence used to confirm this patient's identity…"
        [attr.maxlength]="maxJustificationLength"
        required
        [attr.aria-invalid]="showJustificationError()"
        [attr.aria-describedby]="
          showJustificationError() ? 'override-justification-error' : 'override-justification-count'
        "
      ></textarea>
      <!--
        The counter is always present so the cap is discoverable before the
        browser silently stops accepting keystrokes at maxlength. Not a live
        region: it changes on every keypress, which would make a screen reader
        unusable — it is reached through the textarea's description instead.
      -->
      <p
        id="override-justification-count"
        class="override-justification__count fs-12 m-0"
        aria-live="off"
      >
        {{ justificationLength() }}/{{ maxJustificationLength }} characters
      </p>
      <!--
        Bound conditionally so aria-describedby never points at an element that
        isn't rendered. No role="alert": this fires on blur, and an assertive
        live region would interrupt the screen reader as the user tabs on.
      -->
      @if (showJustificationError()) {
      <p id="override-justification-error" class="field__error fs-12 m-0">
        {{ justificationError() }}
      </p>
      }
    </div>
    <div class="mismatch-ack flex align-start gap-10">
      <input
        type="checkbox"
        id="mismatch-ack"
        class="mismatch-ack__checkbox"
        [checked]="mismatchAcknowledged()"
        (change)="toggleMismatchAcknowledgment($any($event.target).checked)"
      />
      <label for="mismatch-ack" class="mismatch-ack__label fs-12"
        >I acknowledge that these fields do not match the patient record and I am overriding
        identity verification based on additional confirmed evidence. This action will be
        permanently recorded in the audit log.</label
      >
    </div>
    } @if (confirmError()) {
    <p class="confirm-error fs-12" role="alert">{{ confirmError() }}</p>
    }
    <div class="modal-actions">
      <button
        type="button"
        class="secondary-button fw-600"
        (click)="cancel()"
        [disabled]="isConfirming()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="fw-600 flex align-center gap-8"
        [class.success-button]="!hasMismatch()"
        [class.warning-button]="hasMismatch()"
        (click)="confirm()"
        [disabled]="!canConfirm()"
        [attr.aria-describedby]="
          hasMismatch() && !canConfirm() && !isConfirming() ? 'confirm-disabled-reason' : null
        "
      >
        <app-icon
          name="link"
          size="xs"
          color="custom"
          customColor="currentColor"
          role="presentation"
        ></app-icon>
        <span>{{ confirmButtonLabel() }}</span>
      </button>
    </div>
    <!-- Always-present live region so the helper's appearance is announced. -->
    <div aria-live="polite">
      @if (hasMismatch() && !canConfirm() && !isConfirming()) {
      <p id="confirm-disabled-reason" class="mismatch-helper-text fs-12">
        Provide a justification and check the acknowledgment above to enable confirmation
      </p>
      }
    </div>
  </div>
</div>
